import { FunctionComponent, ReactNode, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextToiTeaser from '@contexts/toiTeaser'
import { TOITeaserLayoutContextType } from '@contexts/toiTeaser'

interface StyledSpecialPromoLineProps {
  alignment: TOITeaserLayoutContextType['mainTextAlignment']['h']
}

const { TOITeaserLayoutContext } = contextToiTeaser

const StyledSpecialPromoLineColorContainer = styled.div`
  flex: 1;
`

const StyledSpecialPromoLineColorElement = styled.div`
  ${({
    theme: {
      colors: { white },
    },
  }) => css`
    width: 100%;
    height: 2px;
    background-color: ${white};
  `}
`

const StyledLabelContainer = styled.div`
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const StyledSpecialPromoLine = styled.div<StyledSpecialPromoLineProps>`
  ${({ alignment }) => {
    return css`
      position: absolute;
      box-sizing: border-box;
      display: flex;
      flex-direction: ${alignment === 'left' ? 'row' : 'row-reverse'};
      width: 100%;
      top: 8px;
      left: 0;
      padding: 0 8px 0 10px;
      line-height: 0;
    `
  }}
`

const SpecialPromoLine: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const { mainTextAlignment } = useContext(TOITeaserLayoutContext)

  return (
    <StyledSpecialPromoLine alignment={mainTextAlignment['h']}>
      <StyledSpecialPromoLineColorContainer>
        <StyledSpecialPromoLineColorElement />
      </StyledSpecialPromoLineColorContainer>
      <StyledLabelContainer>{children}</StyledLabelContainer>
    </StyledSpecialPromoLine>
  )
}

export default SpecialPromoLine
